import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class MathSymbolsIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 18 18" {...props}>
                <path d="M3.25 4.71973H8.25V6.21973H3.25V4.71973Z" fill="currentColor"/>
                <path d="M15 12.75H10V14.25H15V12.75Z" fill="currentColor"/>
                <path d="M10 10.25H15V11.75H10V10.25Z" fill="currentColor"/>
                <path d="M5 15H6.5V13H8.5V11.5H6.5V9.5H5V11.5H3V13H5V15Z" fill="currentColor"/>
                <path d="M12.5003 6.54L11.0903 7.95L10.0303 6.89L11.4403 5.47L10.0303 4.06L11.0903 3L12.5003 4.41L13.9103 3L14.9703 4.06L13.5603 5.47L14.9703 6.89L13.9103 7.95L12.5003 6.54Z" fill="currentColor"/>
                <path d="M2 0H16C17.1 0 18 0.9 18 2V16C18 17.1 17.1 18 16 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0ZM2 16H16V2H2V16Z" fill="currentColor"/>
            </AbstractIcon>
        );
    }
}
